// ============================================================
// 备案信息配置
// 备案通过后，只需修改本文件一处即可全局生效（登录页 / 后台 / 客户门户）
// 获取位置：腾讯云备案控制台 → 我的备案 → 复制「ICP 备案号」
// 格式示例：豫ICP备2023033662号
// 公安备案号（公安备案通过后填写，目前先留空）：豫公网安备 XXXXXXXXXXXXXX号
// ============================================================
export const BEIAN = {
  company: '荣牧科技',
  // ICP 备案号（已通过审核，填入真实编号）
  icp: '豫ICP备2023033662号',
  icpUrl: 'https://beian.miit.gov.cn',
  // 公安联网备案号（公安备案通过后填写，留空则不显示）
  police: '',
  policeUrl: 'https://beian.mps.gov.cn',
};
